<template>
    <div>
        <b-breadcrumb :items="itemsBread"></b-breadcrumb>
        <div class="p-3">
            <h2 class="mb-5">Add Service Category</h2>
            <ElementCategories category_id="2" elementName="Service"></ElementCategories>
        </div>
    </div>
</template>

<script>
import ElementCategories from "@/components/ElementComponents/ElementCategories";

export default {
    components: {
        ElementCategories,
    },
    methods: {},
    data(){
        return{
            itemsBread: [
                {
                    text: 'Home',
                    to: '/dashboard'
                }, {
                    text: 'Services',
                    to: '/services/all'
                }, {
                    text: 'Service Category',
                    href: '#'
                }
            ],
        }
    }
};
</script>
